import { render, staticRenderFns } from "./TemplateEditor.vue?vue&type=template&id=57c438c3&scoped=true&"
import script from "./TemplateEditor.vue?vue&type=script&lang=js&"
export * from "./TemplateEditor.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEditor.vue?vue&type=style&index=0&id=57c438c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c438c3",
  null
  
)

export default component.exports